/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Principles_TitleInputs */

const en_about_principles_title = /** @type {(inputs: About_Principles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you can expect from us.`)
};

const lv_about_principles_title = /** @type {(inputs: About_Principles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ko no mums varat sagaidīt.`)
};

/**
* | output |
* | --- |
* | "What you can expect from us." |
*
* @param {About_Principles_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const about_principles_title = /** @type {((inputs?: About_Principles_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Principles_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_about_principles_title(inputs)
	return en_about_principles_title(inputs)
});